import * as React from 'react';
import Helmet from 'react-helmet';

export const Head: React.FunctionComponent = () => (
  <Helmet>
    <title>Aspire Ambassador Program</title>
    <meta name="description" content="Join the Aspire Ambassador Program" />
  </Helmet>
  );
